import React from "react";

function footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <a
            href="https://github.com/michaelnjuguna"
            target="_blank"
            rel="noreferrer"
          >
            Designed & built by Michael Njuguna.
          </a>
        </div>
      </div>
    </footer>
  );
}

export default footer;
